<footer>
  <!--<span>{{ today | date: 'yyyy-MM-dd' }}</span>-->
  Fototax © 2018
</footer>
